import { useState, useCallback } from 'react';
import { obrasSocialesAPI } from '../../../core/api/api';

export const useObraSocialRequisitos = () => {
  const [requisitos, setRequisitos] = useState([]);
  const [loading, setLoading] = useState(false);

  const cargar = useCallback(async (filtros = {}) => {
    setLoading(true);
    try {
      const params = {};
      if (filtros.idObraSocial) params.idObraSocial = filtros.idObraSocial;
      if (filtros.idRequisito) params.idRequisito = filtros.idRequisito;
      if (filtros.idTipoEstudio) params.idTipoEstudio = filtros.idTipoEstudio;
      const res = await obrasSocialesAPI.listarRequisitos(params);
      setRequisitos(res.data || []);
    } finally {
      setLoading(false);
    }
  }, []);

  const guardar = useCallback(async (data) => {
    setLoading(true);
    try {
      await obrasSocialesAPI.guardarRequisitos(data);
    } finally {
      setLoading(false);
    }
  }, []);

  const actualizar = useCallback(async (id, data) => {
    setLoading(true);
    try {
      await obrasSocialesAPI.actualizarRequisito(id, data);
    } finally {
      setLoading(false);
    }
  }, []);

  const eliminar = useCallback(async (id) => {
    setLoading(true);
    try {
      await obrasSocialesAPI.eliminarRequisito(id);
    } finally {
      setLoading(false);
    }
  }, []);

  return { requisitos, loading, cargar, guardar, actualizar, eliminar };
};
